function checkUrlForVyhledavani() {
    const currentUrl = window.location.href
    if (currentUrl.includes('vyhledavani')) {
        return true
    } else {
        return false
    }
}

const getCartItems = () => {
    const cart = getShoptetDataLayer('cart')
    const arr = []

    for (let cartItem of cart) {
        const product = { code: `${cartItem.code}`, qty: `${cartItem.quantity}` }
        arr.push(product)
    }
    return arr
}
const saveItems = () => {
    var jsonString = JSON.stringify(getCartItems())
    var xhr = new XMLHttpRequest()
    xhr.open('POST', 'https://api.dominikp.cz/mimedigital/HappyZoo_dopravy', true)
    xhr.setRequestHeader('Content-type', 'application/json')
    xhr.onload = function () {
        console.log(this.responseText)
        localStorage.setItem('disableShipping', this.responseText)
    }
    xhr.send(jsonString)
}
const saveDisabledShippings = () => {
    const nextStepBtn = document.querySelector('a.btn.next-step-forward')

    if (nextStepBtn) {
        nextStepBtn.addEventListener('click', () => {
            saveItems()
        })
    }

    saveItems()

    document.addEventListener('ShoptetCartSetCartItemAmount', saveItems)
    document.addEventListener('ShoptetCartDeleteCartItem', saveItems)
}
const formatShippingName = () => {
    const shippings = document.querySelectorAll("#order-shipping-methods div[data-testid='shippingMethod']")

    if (shippings) {
        shippings.forEach((item) => {
            const shippingEl = item.querySelector('.shipping-billing-name')

            if (shippingEl) {
                const shipping = shippingEl.textContent.trim()

                if (shipping.includes('#')) {
                    const [formattedName] = shipping.split('#')
                    shippingEl.textContent = formattedName
                }
            }
        })
    }

    const krok3 = document.querySelector('.id--17')
    const recapBox = document.querySelector('#summary-box')

    if (recapBox && krok3) {
        const recapItem = document.querySelectorAll('.recapitulation-single span')

        if (recapItem) {
            recapItem.forEach((item) => {
                if (item.textContent === 'Způsob dopravy') {
                    const shipping = item.nextElementSibling?.childNodes[2]

                    if (shipping.textContent.includes('#')) {
                        const [formattedName] = shipping.textContent.split('#')
                        shipping.textContent = formattedName
                    }
                }
            })
        }
    }
}
const hideShipping = () => {
    if (localStorage.getItem('disableShipping')) {
        let data = JSON.parse(localStorage.getItem('disableShipping'))
        const shippings = document.querySelectorAll(
            "#order-shipping-methods div[data-testid='shippingMethod']"
        )

        if (shippings) {
            shippings.forEach((item) => {
                const shippingEl = item.querySelector('.shipping-billing-name')

                if (shippingEl) {
                    const shipping = shippingEl.textContent.trim()

                    for (let disabledShipping of data) {
                        if (disabledShipping.dopravce === shipping) {
                            shippingEl.closest('.radio-wrapper').classList.add('hide')
                        }
                    }
                }
            })
        }
    }
}

const disableNextBtn = () => {
    const activeShipping = document.querySelector('#order-shipping-methods .active')
    const nextBtn = document.querySelector('#orderFormButton')
    const nextstep = document.querySelector('.next-step')
    let shippingName

    document.addEventListener('TDOMContentLoaded', () => {
        shippingName = document.querySelector(
            '#checkoutSidebar #shipping-billing-summary .recapitulation-shipping-billing-info'
        )
    })

    if (activeShipping && activeShipping.classList.contains('hide')) {
        // shippingName.style.display = 'hide'

        if (nextBtn && nextBtn) {
            nextstep.classList.add('disable-btn')
            nextBtn.classList.add('disabled')
        }
    } else {
        if (nextBtn && nextBtn) {
            nextstep.classList.remove('disable-btn')
            nextBtn.classList.remove('disabled')
            // shippingName.style.display = 'flex'
        }
    }
}
function generateCartQuery() {
    const codes = document.querySelectorAll('.removeable')

    if (codes) {
        let codesArr = []

        codes.forEach((code, i) => {
            let pCode = code.getAttribute('data-micro-sku')

            if (i === codes.length - 1) {
                const codeString = `[]=${pCode}`
                codesArr.push(codeString)
            } else {
                const codeString = `[]=${pCode}&codes`
                codesArr.push(codeString)
            }
        })

        return codesArr.join('')
    }
}
const cartAboveQty = async () => {
    const finalQuery = generateCartQuery()
    const url = `https://aplikace.mimedigital.cz/supporting-endpoints.happy-zoo/?codes${finalQuery}`
    const response = await fetch(url)

    const productStocks = await response.json()
    console.log(productStocks)

    let alreadyLoggedProducts = []

    const products = document.querySelectorAll('.removeable')

    for (let product of products) {
        const pCode = product.getAttribute('data-micro-sku')
        const qty = Number(product.querySelector('.quantity .amount')?.value)
        let finalStockQty = 0

        for (const item of Object.entries(productStocks)) {
            const itemCode = item[1].code
            const stockQty = item[1].amount

            if (itemCode === pCode) {
                finalStockQty += stockQty
            }
        }

        if (qty > finalStockQty) {
            if (!alreadyLoggedProducts.includes(pCode)) {
                alreadyLoggedProducts.push(pCode)
            }
        }
    }

    document.addEventListener('ShoptetDOMCartContentLoaded', () => {
        // const products = getShoptetDataLayer('cart')
        const products = document.querySelectorAll('.removeable')

        for (let product of products) {
            const pCode = product.getAttribute('data-micro-sku')
            const qty = Number(product.querySelector('.quantity .amount')?.value)
            let finalStockQty = 0
            let paramX = false

            for (const item of Object.entries(productStocks)) {
                const itemCode = item[1].code
                const stockQty = item[1].amount
                const param = item[1].paramQualityStandard

                if (itemCode === pCode && param === 'X') {
                    finalStockQty += stockQty
                    paramX = true
                }
            }

            // console.log(qty)
            // console.log(finalStockQty)
            // console.log(alreadyLoggedProducts)

            if (paramX) {
                if (qty > finalStockQty) {
                    if (!alreadyLoggedProducts.includes(pCode)) {
                        alreadyLoggedProducts.push(pCode)
                        showError(
                            'Vložili jste do košíku více kusů, než máme momentálně skladem. Doba expedice Vaší objednávky se tak může prodloužit o počet dní uvedený v detailu produktu.'
                        )
                    }
                }

                if (qty < finalStockQty) {
                    if (alreadyLoggedProducts.includes(pCode)) {
                        const index = alreadyLoggedProducts.indexOf(pCode)

                        if (index !== -1) {
                            alreadyLoggedProducts.splice(index, 1)
                        }
                    }
                }
            }
        }
    })
}

const mobileWay = () => {
    if ($(window).width() < 767) {
        const transportWays = document.querySelectorAll('.shipping-billing-table .radio-wrapper')

        if (!transportWays) return

        for (const transportItem of transportWays) {
            const chooseBranch = transportItem.querySelector('.choose-branch')
            const paymentInfo = transportItem.querySelector('.payment-info')
            const paymentLogo = transportItem.querySelector('.payment-logo')
            const paymentShippingPrice = transportItem.querySelector('.payment-shipping-price')
            const priceWrapper = `<div class = "transport-price-wrapper"></div>`

            paymentInfo.insertAdjacentHTML('afterend', priceWrapper)

            const priceWrapperElem = transportItem.querySelector('.transport-price-wrapper')

            if (chooseBranch) priceWrapperElem.classList.add('branch')

            priceWrapperElem.append(paymentLogo, paymentShippingPrice)
        }
    }
}

$(document).ready(function () {
    const isCart = document.querySelector('.ordering-process')
    const krok1 = document.querySelector('.id--9')
    const krok2 = document.querySelector('.id--16')
    const krok3 = document.querySelector('.id--17')

    if (isCart) {
        const step3Header = document.querySelector('.step.step-3 span')

        if (step3Header) {
            step3Header.textContent = 'Informace o Vás'
        }

        if (krok1) {
            const isAdmin = document.querySelector('.admin-bar')

            if (isAdmin) {
                cartAboveQty()
            }
            saveDisabledShippings()
        }
        if (krok2) {
            hideShipping()
            formatShippingName()
            disableNextBtn()
            mobileWay()

            document.querySelector('.co-delivery-method')?.classList.add('ready')

            document.addEventListener('ShoptetShippingMethodUpdated', () => {
                console.log('day')
                disableNextBtn()
            })
        }
        if (krok3) {
            formatShippingName()

            let intervalId = setInterval(isPoint, 100)

            function isPoint() {
                const point = document.querySelector('.card .card-text b')

                if (point) {
                    clearInterval(intervalId)
                    console.log(point)
                }
            }

            document.addEventListener('ShoptetSuccessfulValidation', () => {
                localStorage.removeItem('disableShipping')
            })
        }
    }
})



function removeFlags() {
    if ($(".id--17").length) {
      $('[data-testid="recapDeliveryMethod"]:contains("GLS")').each(function () {
        $('.country-flags').addClass("no-flags");
        $(".country-flag:not(.country-flag-preferred)").remove();
      });
      }
  }
  removeFlags();
  document.addEventListener('ShoptetDOMContentLoaded', function () {
      removeFlags();
  });

  $(window).load(function() {
	$('.gls-parcel-shop-choose').each(function () {
		var toolTipEl = $(this).closest('.radio-wrapper').find('.question-tooltip');
		var toolTipText = toolTipEl.attr('data-original-title');
		if (toolTipText !== undefined) {
			var newToolTip = toolTipText.replace(/(\[nogroup="(([0-9]+,? ?)+)" ?\/\])/, '');
			var match = /(\[nogroup="(([0-9]+,? ?)+)" ?\/\])/.exec(toolTipText);

			if (newToolTip.trim().length > 0) {
				toolTipEl.attr('data-original-title', newToolTip);
			} else {
				toolTipEl.hide();
			}
			if (match !== null && match[2] !== undefined) {
				toolTipEl.attr('data-gls-nogroup', match[2].trim());
			}
		}
	})

	$(document).on('click', '.gls-parcel-shop-choose a', function(e) {
		e.stopImmediatePropagation();
		$('#cboxClose').remove();
		var toolTipEl = $(this).closest('.radio-wrapper').find('.question-tooltip');
		var noGroupStr = toolTipEl.attr('data-gls-nogroup') ?? '';
		var noGroup = '';
		noGroupStr.split(',').forEach(function (val) {
			noGroup += 'nogroup[]=' + val.trim() + '&'
		})
		shoptet.modal.open({
			html: '<iframe src="https://maps.gls-czech.cz/?'+noGroup+'find=1" frameBorder="0" style="border: 0" width="1200" height="800"></iframe>',
			width: shoptet.modal.config.widthLg,
			className: shoptet.modal.config.classLg,
			onComplete: function() {
				shoptet.modal.shoptetResize()
				$('#cboxClose').remove()
			},
			onCleanup: function() {
			}
		})
	})

	$(document).on('click', '.gls-parcel-shop-choose-branch', function() {
		var branchId = $(this).data('parce-id');
		$('#gls-parcel-shop-hidden').val(branchId);

	})

	window.addEventListener("message", (event) => {
		if (event.origin === 'https://maps.gls-czech.cz'){
			if (event.data.event_id === 'ps_data_handover') {
				$('.radio-wrapper.active .gls-parcel-shop-choose').html(event.data.parcelshop.detail.name + '' + event.data.parcelshop.detail.address + ', ' + event.data.parcelshop.detail.city + '<a href="#" class="chosen">Změnit</a>')
				$('.radio-wrapper.active .gls-parcel-shop-choose').closest('.radio-wrapper').find('[name="shippingId"]').data('parce-id', event.data.parcelshop.detail.pclshopid);
				$('#gls-parcel-shop-hidden').val(event.data.parcelshop.detail.pclshopid);
				$.fn.colorbox.close();
			} else if (event.data.event_id === 'closeWidget') {
				$.fn.colorbox.close();
			}
		}
	}, false);
})

var fastOrder = function (shippingMethods, priceLimit) {
	const storageKey = 'mime-delivery';
	const billingAddressBlock = $('.co-billing-address');
	const contactInformationBlock = $('.co-contact-information');
	const requiredFields = ['billStreet', 'billHouseNumber', 'billCity', 'billZip'];
	const getCartPrice = function () {
		return getShoptetDataLayer().cartInfo.getNoBillingShippingPrice.withVat;
	}

	const getShippingId = function () {
		const id = localStorage.getItem(storageKey);
		return id ? parseInt(id) : null;
	}

	const setRequiredFileds = function () {
		requiredFields.forEach(function (field) {
			const input = $(`#${field}`);
			const label = $(`[for="${field}"]`);
			label.html('<span class="required-asterisk">' + label.text() + '</span>');
			input.addClass('js-validate js-validate-required')
		});
	}


	const setSuspendedFields = function () {
		requiredFields.forEach(function (field) {
			toggleRequiredAttributes($(`#${field}`).closest('.js-validated-element-wrapper'), "remove", false)
		});
	}

	const removeSuspendedFields = function () {
		requiredFields.forEach(function (field) {
			toggleRequiredAttributes($(`#${field}`).closest('.js-validated-element-wrapper'), "add", false)
		});
	}

	if(window.location.href.indexOf('objednavka/krok-1') > -1) {
		$(document).on('click', '#orderFormButton', function(e) {
			localStorage.setItem(storageKey, $('[name="shippingId"]:checked').val());
		})
	}

	if(window.location.href.indexOf('objednavka/krok-2') > -1) {
		setRequiredFileds();

		if(
			shippingMethods.indexOf(getShippingId()) > -1 &&
			getCartPrice() < priceLimit
		) {
			setSuspendedFields();
			billingAddressBlock.addClass('js-hidden');
			contactInformationBlock.append(`<div class="form-group">
                <input id="add-invoice-address" type="checkbox">
                <label for="add-invoice-address" class="whole-width">Chci zadat fakturační adresu</label>
            </div>`);
		} else {
			removeSuspendedFields();
		}
	}

	$('#add-invoice-address').on('change', function() {
		if ($('#add-invoice-address').is(':checked')) {
			billingAddressBlock.addClass('visible');
			removeSuspendedFields();
		} else {
			billingAddressBlock.removeClass('visible');
			setSuspendedFields();
		}
	})
}
fastOrder([109, 124, 103, 17, 4, 160], 10000);



/*
	if(window.location.href.indexOf('objednavka/krok-1') > -1) {
	$(document).on('click', '#orderFormButton', function(e) {
		localStorage.setItem('mime-delivery', $('[name="shippingId"]:checked').val());
	})
}

	if(window.location.href.indexOf('objednavka/krok-2') > -1) {
	// alert(localStorage.getItem('mime-delivery'))
	$('.co-billing-address').hide()
	$('h4:contains(\'Fakturační a dodací adresa\')').hide();
	$('h4:contains(\'Fakturační a dodací adresa\')').before(`<div class="form-group">
                <input id="add-invoice-address" type="checkbox">
                <label for="add-invoice-address" class="whole-width">Chci zadat fakturační adresu</label>
            </div>`);
	$(document).on('change', '#add-invoice-address', function() {
	if($(this).is(':checked')) {
	$('.co-billing-address').show()
	$('h4:contains(\'Fakturační a dodací adresa\')').show();
} else {
	$('.co-billing-address').hide()
	$('h4:contains(\'Fakturační a dodací adresa\')').hide();
}
})

	$('[for="billStreet"]').html('<span class="required-asterisk">' + $('[for="billStreet"]').text() + '</span>')
	$('[for="billCity"]').html('<span class="required-asterisk">' + $('[for="billCity"]').text() + '</span>')
}*/

if($('.admin-logged.id--16').length){
    
    const itemsInCart = [];

    $('.cart-item').each(function () {
        const code = $(this).data('micro-sku').toString();
        const amountText = $(this).find('.cart-item-amount').clone().children('.unit-value').remove().end().text().trim();
        const amount = parseInt(amountText, 10) || 1;

        if (code) {
            itemsInCart.push({ code, amount });
        }
    });
    if (itemsInCart.length > 0) {
        $.ajax({
            url: 'https://php.shopcode.cz/api/happyzoo/api-delivery.php',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ items: itemsInCart }), // ← změna tady
            success: function (response) {
                console.log(response)
                const shoptetData = dataLayer.find(entry => entry.shoptet && entry.shoptet.cartInfo);
                if (shoptetData) {
                    const cartItems = shoptetData.shoptet.cartInfo.cartItems;
                    let totalWeight = 0;
                    cartItems.forEach(item => {
                        const weight = parseFloat(item.weight || 0);
                        const qty = parseInt(item.quantity || 0);
                        totalWeight += weight * qty;
                    });
                    if(response.total_size_value>32.9){
                        $('.order-summary-item.price').after('<div class="deliveryType"><span class="left">Typ zásilky:</span> <span class="right">Nadrozměrná</span></div>')
                    }
                    else{
                        $('.order-summary-item.price').after('<div class="deliveryType"><span class="left">Typ zásilky:</span> <span class="right">Standardní</span></div>') 
                    }
                    $('.order-summary-item.price').after('<div class="weight"><span class="left">Hmotnost zásilky:</span> <span class="right">cca '+totalWeight.toFixed(1)+' kg</span></div>');
                }
                const allowedIds = response.delivery_options.map(option => String(option.delivery_id));  
                let fallbackNeeded = false;             
                $('#order-shipping-methods input[name="shippingId"]').each(function () {
                    const shippingId = $(this).val();
                    const wrapper = $(this).closest('.radio-wrapper');
                    if (!allowedIds.includes(shippingId)) {
                         wrapper.addClass('hide');
                         if (wrapper.hasClass('active')) {
                            fallbackNeeded = true;
                        }
                    }
                });
                if (fallbackNeeded) {
                    $('#order-shipping-methods>div.active').removeClass('active');
                    $('#order-shipping-methods>div.active input').off('click');
                    const fallbackRadio = $('#shippingId-4');
                    $('#order-shipping-methods>div input#shippingId-4').closest('.radio-wrapper').addClass('active');
                    $('#order-shipping-methods>div input#shippingId-4').trigger('click');
                    shoptet.checkoutShared.callShippingBillingRelations();
                    shoptet.checkoutShared.replacingChosenShippingAndBilling();
                }
                
            }
        });
    }

    var customPlace = [];
  var hiddenShipping = false;
  $('#order-shipping-methods .radio-wrapper').each(function() {
    var shippingElement = $(this);
    var shippingElementId = shippingElement.attr('id'); 
    if (shippingId.includes(shippingElementId)) {
      var shippingName = shippingElement.find('.shipping-billing-name').text().trim();
      var shippingPrice = shippingElement.find('.payment-shipping-price').text().trim();
      var shippingImage = shippingElement.find('.payment-logo img').attr('src');
      var shippingGuid = shippingElement.find('input').attr('data-guid');
      customPlace.push({
          id: shippingElementId,
          name: shippingName,
          price: shippingPrice,
          image: shippingImage,
          guid: shippingGuid
      });

        shippingElement.addClass('hidden');
        hiddenShipping = true;
    }
  });
  if (hiddenShipping) {
    $('#order-shipping-methods').append(`
        <div class="customPlace">
        
            <label>
              <span class="payment-info"><b class="shipping-billing-name">${vydejnaUtulek}</b><strong>Zvolte odběrné místo</strong></span>
              <span class="payment-logo"><img src="https://cdn.myshoptet.com/usr/www.happyzoo.cz/user/logos/logohappyzoo.svg" alt="" loading="eager"></span>
              <strong class="payment-shipping-price" data-preserve-value="1" data-shipping-price-wv="49" data-shipping-price-wov="0" data-shipping-price-vat="0" data-shipping-price-id="86" data-testid="billingMethodPrice">1 Kč</strong>
            </label>
        </div>
    `);
  }

  if (customPlace.length > 0) {
    var placesHtml = `<div class="customPlacesInner">
                        <h3>Vyberte si útulek</h3>
                        <ul>`;

    customPlace.forEach(function(place) {
        placesHtml += `
            <li>
                <span><strong>${place.name}</strong><strong class="price">${place.price}</strong></span>
                <span class="btn btn-primary" data-guid="${place.guid}">Zvolit</span>
            </li>`;
    });

    placesHtml += `</ul></div>`;
}

  $('html').on('click', '.customPlace', function(){
    $.colorbox({
      html: placesHtml,
      width: 700,
      maxWidth: "95%",
      height: 600,
      maxHeight: "95%",
      className: "customPlacesColorbox",
      onComplete: function() {
           
      }
    });
  })
  $('html').on('click', '.customPlacesInner li', function(){
    $.colorbox.close();
    $('#order-shipping-methods>div.active').removeClass('active')
    $('#order-shipping-methods>div.active input').off('click')
    $('#order-shipping-methods>div input[data-guid="'+$(this).find('span.btn').attr('data-guid')+'"]').closest('.radio-wrapper').addClass('active')
    $('#order-shipping-methods>div input[data-guid="'+$(this).find('span.btn').attr('data-guid')+'"]').trigger('click');
    $('.customPlace .payment-info strong').text($('#order-shipping-methods>div input[data-guid="'+$(this).attr('data-guid')+'"]').closest('.radio-wrapper').find('.payment-info b.shipping-billing-name').text())
    shoptet.checkoutShared.callShippingBillingRelations();
    shoptet.checkoutShared.replacingChosenShippingAndBilling();
    $('.next-step').removeClass('disable-btn');
    $('.next-step button').removeClass('disabled');
  })
  updateActivePlaces()
  shoptet.scripts.setCustomCallback('shoptet.checkoutShared.displaySelectedPriceByShippingBillingMethods', function(args) {
    setTimeout(function(){
      updateActivePlaces()
    }, 300)
  });


  function updateActivePlaces() {
    $('.customPlace').each(function() {
        var found = false;
        var customPlaceElement = $(this);
        shippingId.forEach(function(place) {
            if ($('#order-shipping-methods').find('div.active#'+place).length > 0) {
                found = true;
            }
        });
        if (found) {
            customPlaceElement.addClass('activePlace');
            $('.customPlace .payment-info strong').text($('#order-shipping-methods>div.active').find('.payment-info b.shipping-billing-name').text())
        } else {
            customPlaceElement.removeClass('activePlace');
        }
    });
  }

}